module.exports = __webpack_public_path__ + "static/media/affiliates-get-paid.73641529.gif";